module.exports = __webpack_public_path__ + "static/side-img-5-e4a86b789d2561d2d136de7affe4ea0c.png";